function reinitBadgeObserver() {
  let badgeUpdateTimer;

  const observer = new MutationObserver((mutations, obs) => {
    const hits = document.querySelector('.mz-hits');
    if (hits) {
      if (hits.querySelector('.mm-badges-wrapper')) {
        clearTimeout(badgeUpdateTimer);
        badgeUpdateTimer = setTimeout(() => {
          updateBadges();
          obs.disconnect();
        }, 250);
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

document.addEventListener('DOMContentLoaded', function() {
  if (!window.mz) {
    return
  }
  if (mz.context.filterShow) {
    // placeholder
  }
  function lazyLoadItem(el, item, callback) {
    fetch(`/collections/all?section_id=${mz.sectionId}&sort_by=mezereon:${item.handle}`)
    .then((response) => response.text())
      .then((responseText) => {
      
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const mzCardProduct = html.querySelector('.mz-card-product');
              
      // Modify "Add to cart" button text for pre-order products
      const isPreorder = item.tags && Array.isArray(item.tags) && item.tags.some(t => typeof t === 'string' && (t.toLowerCase().startsWith('preorder') || t.toLowerCase().startsWith('pre_order')));
      
      // console.log(`[Mezereon Debug] Product: ${item.handle} | Tags:`, item.tags, `| isPreorder:`, isPreorder);
      
      if (isPreorder && mzCardProduct) {
        // Target standard Shopify add-to-cart buttons inside the card
        const atcButtons = mzCardProduct.querySelectorAll('button[name="add"], .quick-add__submit');
        // console.log(`[Mezereon Debug] Found ${atcButtons.length} Add to Cart buttons for ${item.handle}.`);
        
        atcButtons.forEach((btn, i) => {
          // console.log(`[Mezereon Debug] Button ${i} disabled status:`, btn.disabled);
          
          // Enable the button for pre-orders
          btn.disabled = false;
          btn.removeAttribute('disabled');
          btn.setAttribute('aria-disabled', 'false');
          
          // Safely target the text span, ignoring the SVG icon and loading spinner
          const btnSpan = btn.querySelector('span:not(.sold-out-message)');
          // console.log(`[Mezereon Debug] Button ${i} span target:`, btnSpan);
          
          if (btnSpan) {
            btnSpan.textContent = 'Précommander';
          }
        });
      }

      callback(mzCardProduct.innerHTML);
      afterLazyLoad();

    })
    .catch((e) => {
      // console.log(e);
    });    
  }
  function afterUpdate() {
    reinitBadgeObserver();

    //Grid-list view selector
    if (window.innerWidth > 768) {
      var params = new URLSearchParams(window.location.search);
      var paramVitems = params.get("vitems");

      if (!params.has("vitems") || paramVitems == "grid") {
        $(".templateSelectorList").removeClass("active");
        $(".templateSelectorGrid").addClass("active");
      }
    }

    //Change filters SVG on mobile
    var mySVG = $(".mz-action-bar-group .mz-filter svg");
    var myPath = $(".mz-action-bar-group .mz-filter svg path");
    if (mySVG.attr("viewBox") != "0 0 24 24") {
      mySVG.attr("viewBox", "0 0 24 24");
      myPath.attr(
        "d",
        "M20.5 5H8.82a3 3 0 1 0 0 2H20.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5M6 7a1 1 0 1 1 1-1 1 1 0 0 1-1 1m14.5 4h-5.68a3 3 0 0 0-5.64 0H3.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5.68a3 3 0 0 0 5.64 0h5.68a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5M12 13a1 1 0 1 1 1-1 1 1 0 0 1-1 1m6 2a3 3 0 0 0-2.82 2H3.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h11.68A3 3 0 1 0 18 15m0 4a1 1 0 1 1 1-1 1 1 0 0 1-1 1",
      );

      mySVG.after("<span class='mz-filter-text'>Filtre</span>");
    }

    setFilterExplanationIcons();
  }
  function afterLazyLoad(){
    window.compareGridRender();
    
    if (window.zooomyColl) {
      window.zooomyColl($);
      $(".zoomywishid").css("display", "block");
    }

    
    //Product reviews
    if (window.judgeme.customizeBadges) {
      window.judgeme.customizeBadges();
    }
  }

  function reloadSection(e) {
    if (e.detail.sectionId !== mz.sectionId){
      return
    }
    mz.initializeVueApp()
  }
  function closeSearch() {
    document.querySelector('.search-modal__close-button').click()
  }
  function setFilterExplanationIcons() {
    let facetElements = document.querySelectorAll(".mz-aggs-vertical .mz-facet .mz-label");
   
    document.querySelectorAll('.filtersDialog').forEach(function(el) {
      el.style.display = 'none';
    });

    facetElements.forEach((facet, index) => {
      let facetName = facet.parentNode.getAttribute("data-facet-name");
      if (
        document.getElementById("filterDialog_modal_" + facetName) &&
        facet.querySelectorAll(".filtersDialogBtn").length == 0
      ) {
        facet.innerHTML +=
          "<span class='filtersDialogBtn' id='filtersDialogBtn_"+facetName +"' data-dialog-id='" +
          facetName +
          "'><svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke-width=1.5 stroke='currentColor' className='size-6'><path strokeLinecap='round' strokeLinejoin='round' d='m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z' /></svg></span>";
      }  
    });

    if(document.querySelectorAll(".filtersDialogBtn").length > 0){
      document.querySelectorAll(".filtersDialogBtn").forEach(div => {

        if(document.getElementById('filtersDialogBtn_'+div.getAttribute("data-dialog-id"))){

          document.getElementById('filterDialog_modal_'+div.getAttribute("data-dialog-id")).style.display = 'block';

          tippy('#'+div.id, {
            content: document.getElementById('filterDialog_modal_'+div.getAttribute("data-dialog-id")),
            allowHTML: true,
            interactive: true,
            trigger: 'click',
            //placement: 'top',
            appendTo: document.body,
            theme: 'popup',
            getReferenceClientRect: () => ({
              width: 0,
              height: 0,
              top: window.innerHeight/2,
              bottom: window.innerHeight/2,
              left: window.innerWidth / 2,
              right: window.innerWidth / 2,
            }),
            onShow(instance) {
              document.getElementById('tippy-overlay').style.display = 'block';
            },
            onHide(instance) {
              document.getElementById('tippy-overlay').style.display = 'none';
            }
          });
        }else{
          document.getElementById('filterDialog_modal_'+div.getAttribute("data-dialog-id")).style.display = 'none';
        }

      });
    }  
  }
  if (mz.app && mz.app.$bus) {
    mz.app.$bus.on('after-update', afterUpdate)
    mz.app.$bus.on('lazy-load-item', lazyLoadItem) 
    if (Shopify.designMode) {
      document.addEventListener('shopify:section:load', (e) => reloadSection(e))
    }
  }
  if (mz.suggest && mz.suggest.$bus) {
    mz.suggest.$bus.on('run-query', closeSearch)
  }
})

function updateBadges() {
  // Get metaobjects from session
  const session = JSON.parse(sessionStorage.getItem("store"));
  const metaobjects = session.data.metaobjects.nodes;

  // Make sure we are on collection or search page
  if (window.themePage.name !== "collection" && window.themePage.name !== "page") return;

        // Get all product > badge wrappers
      let badgeWrappers = document.querySelectorAll(".mz-hits-container .grid__item .mm-badges-wrapper");
      if (badgeWrappers.length === 0) return;

      // Loop through each badge wrapper
      badgeWrappers.forEach((wrapper, index) => {
        let tags = wrapper.dataset.productTags;
        if (typeof tags === "undefined" || tags === "") return;

        // create array from tags
        tags = tags.split(",");
        tags.forEach((tag) => {
          if (tag.includes("condition")) {
            const result = metaobjects.find((obj) =>
              obj.fields.some((field) => field.value.includes(tag)),
            );

            if (!result) return;

            const metaObject = result["fields"].reduce((obj, item) => {
              obj[item.key] = item.value;
              return obj;
            }, {});

            let isActiveCampaign = false;
            const showBadge = metaObject.add_badge_to_product_picture;

            // If the campaign has a start and end date, check if it is active
            if (metaObject.promotion_start_date && metaObject.promotion_end_date) {
              const currentDate = new Date();
              const startDate = new Date(metaObject.promotion_start_date);
              const endDate = new Date(metaObject.promotion_end_date);
              isActiveCampaign = currentDate >= startDate && currentDate <= endDate;
            } else {
              // If the campaign has no start and end date, it is always active
              isActiveCampaign = true;
            }

            // If the campaign is not active or the badge should not be shown, return / do nothing

            if (isActiveCampaign == true && showBadge == "true") {
              const newBadge = document.createElement("div");
              newBadge.className = "mm-badge";
              // Create badge text element
              const badgeText = document.createElement("span");
              badgeText.className = "mm-badge-label";
              badgeText.title = metaObject.badge;
              badgeText.textContent = metaObject.badge;
              // Add badge inner element
              newBadge.appendChild(badgeText);
              wrapper.appendChild(newBadge);
            }
          }
          if (tag.includes("badge")) {
            // console.log('taggy', tag)
          }
        });
      });
}
